"use client";

import { useState } from "react";
import { CollapsibleItem } from "./collapsible-item";
import { FAQ } from "./types";
import { toSentenceCase } from "@/utils/string/to-sentence-case";

interface TabContentProps {
	faqs: FAQ[];
}

export function TabContent({ faqs }: TabContentProps) {
	const [openItems, setOpenItems] = useState<Set<number>>(new Set());

	const toggleItem = (index: number) => {
		setOpenItems(prev => {
			const newSet = new Set(prev);
			if (newSet.has(index)) {
				newSet.delete(index);
			} else {
				newSet.add(index);
			}
			return newSet;
		});
	};

	// Get the category from the first FAQ item to display as section heading
	const categoryName = faqs.length > 0 ? toSentenceCase(faqs[0].category) : "";

	return (
		<div className="space-y-4">
			{categoryName && <h2 className="text-2xl text-center font-semibold text-gray-800 mb-6">{categoryName} FAQs</h2>}
			{faqs.map((faq, index) => (
				<CollapsibleItem key={index} faq={faq} isOpen={openItems.has(index)} onToggle={() => toggleItem(index)} />
			))}
		</div>
	);
}
